"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserFeedback = void 0;
var utils_1 = require("./utils");
var issue_1 = require("./types/issue");
var user_feedback_scss_1 = __importDefault(require("./templates/user-feedback.scss"));
var user_feedback_html_1 = __importDefault(require("./templates/user-feedback.html"));
var UserFeedback = (function () {
    function UserFeedback(storage) {
        this.storage = storage;
    }
    UserFeedback.prototype.cancel = function () {
        this.resolve({ isSent: false, feedbackURL: undefined });
        this.close();
    };
    UserFeedback.prototype.close = function () {
        this.backdropEl.removeEventListener('click', this.closeCb);
        this.closeEl.removeEventListener('click', this.closeCb);
        this.formEl.removeEventListener('submit', this.submitCb);
        this.backdropEl = null;
        this.closeEl = null;
        this.feedbackEl = null;
        this.formEl = null;
        this.subjectEl = null;
        this.submitEl = null;
        this.titleEl = null;
        this.shadow.innerHTML = '';
        this.wrapperEl.innerHTML = '';
        this.wrapperEl.remove();
        this.wrapperEl = null;
    };
    UserFeedback.prototype.injectCSS = function () {
        var style = document.createElement('style');
        style.textContent = user_feedback_scss_1.default.toString();
        this.shadow.append(style);
    };
    UserFeedback.prototype.resolve = function (result) {
        this.deferred.resolve(result);
        this.deferred = null;
    };
    UserFeedback.prototype.show = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                if (this.deferred) {
                    return [2];
                }
                this.options = __assign({ title: 'Feedback', subjectPlaceholder: 'Subject…', feedbackPlaceholder: 'Your feedback…', submitLabel: 'Send' }, (options || {}));
                this.deferred = utils_1.createDeferred();
                this.showModal();
                this.injectCSS();
                return [2, this.deferred.promise];
            });
        });
    };
    UserFeedback.prototype.showModal = function () {
        var _this = this;
        this.wrapperEl = document.createElement('div');
        this.shadow = this.wrapperEl.attachShadow({ mode: 'closed' });
        this.shadow.innerHTML = user_feedback_html_1.default;
        this.titleEl = this.shadow.querySelector('[data-bf-title]');
        this.titleEl.innerText = this.options.title;
        this.subjectEl = this.shadow.querySelector('[data-bf-subject]');
        this.subjectEl.setAttribute('placeholder', this.options.subjectPlaceholder);
        this.feedbackEl = this.shadow.querySelector('[data-bf-feedback]');
        this.feedbackEl.setAttribute('placeholder', this.options.feedbackPlaceholder);
        this.submitEl = this.shadow.querySelector('[data-bf-submit]');
        this.submitEl.innerText = this.options.submitLabel;
        this.closeCb = function () { return _this.cancel(); };
        this.backdropEl = this.shadow.querySelector('[data-bf-backdrop]');
        this.backdropEl.addEventListener('click', this.closeCb);
        this.closeEl = this.shadow.querySelector('[data-bf-close]');
        this.closeEl.addEventListener('click', this.closeCb);
        this.formEl = this.shadow.querySelector('[data-bf-form]');
        this.submitCb = function (e) { return _this.submit(e); };
        this.formEl.addEventListener('submit', this.submitCb);
        var body = document.querySelector('body');
        body.appendChild(this.wrapperEl);
    };
    UserFeedback.prototype.submit = function (e) {
        return __awaiter(this, void 0, void 0, function () {
            var feedbackURL;
            return __generator(this, function (_a) {
                e.preventDefault();
                e.stopPropagation();
                feedbackURL = this.storage.addIssue(issue_1.IssueType.Feedback, this.subjectEl.value, this.feedbackEl.value);
                this.resolve({ isSent: true, feedbackURL: feedbackURL });
                this.close();
                return [2];
            });
        });
    };
    return UserFeedback;
}());
exports.UserFeedback = UserFeedback;
